import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import { Loading } from 'app/components/common/Loading'
import { useDebounce } from 'app/hook'
import { useGetDashboardInfo } from 'app/react-query/hook/dashboard'
import dayjs, { Dayjs } from 'dayjs'
import { useState } from 'react'
import { FilterLayout, RangeTimeEnum } from './Filter'
import {
  EventByTypeLayout,
  InfoData,
  Top10EventHaveMemberLayout,
  Top10MemberLayout,
} from './layouts'
import { EventInSevenDay } from './layouts/EventInSevenDay'

export interface IFilterDashboard {
  rangeTime: RangeTimeEnum
  startDateDayJs?: Dayjs | null
  endDateDayJs?: Dayjs | null
}
const currentYear = dayjs().year()

export const DashboardAdminLayout = () => {
  const [filter, setFilter] = useState<IFilterDashboard>({
    rangeTime: RangeTimeEnum.THIS_YEAR,
    startDateDayJs: dayjs(`${currentYear}-01-01T00:00:00.000Z`),
    endDateDayJs: dayjs(`${currentYear}-12-31T23:59:59.999Z`),
  })

  const paramsDebounce = useDebounce(filter, 500)

  const { data, isLoading } = useGetDashboardInfo({
    startDate: paramsDebounce?.startDateDayJs?.toISOString(),
    endDate: paramsDebounce?.endDateDayJs?.toISOString(),
  })

  return (
    <BaseSpace style={{ position: 'relative' }}>
      <FilterLayout filter={filter} onChange={setFilter} />

      <InfoData data={data} />

      <EventByTypeLayout data={data} />

      <EventInSevenDay />

      <BaseRow align={'top'} justify={'space-between'} gutter={[16, 16]}>
        <BaseCol xl={12} style={{ flex: 1 }}>
          <Top10EventHaveMemberLayout
            top10MemberPrize={data?.top?.top10Activity ?? []}
            isLoading={isLoading}
          />
        </BaseCol>
        <BaseCol xl={12} style={{ flex: 1 }}>
          <Top10MemberLayout
            top10MemberJoinEvent={data?.top?.top10Tum ?? []}
            isLoading={isLoading}
          />
        </BaseCol>
      </BaseRow>

      {isLoading ? <Loading isAbsolute size="default" /> : null}
    </BaseSpace>
  )
}
